import { Button, ThemeIcon, Tooltip } from '@mantine/core';
import { IconSchool, IconVideo } from '@tabler/icons';
import React, { FC } from 'react';
import { RoutingS } from '../Service/RoutingS';
import { MixpanelS } from '../Service/MixpanelS';
import { ConstantS } from '../Service/ConstantS';

type BookitupTutorialIconProps = {
  id?: string;
  testId?: string;
  videoUrl: string;
  name: string;
};

const useTutorialClick = (videoUrl: string, name: string) => {
  const onClick = () => {
    MixpanelS.track(ConstantS.TrackingEvents.OpenVideoTutorial, { name });
    RoutingS.openInNewTab(videoUrl);
  };

  return onClick;
};

const BookitupTutorialIcon: FC<BookitupTutorialIconProps> = ({ id, testId, videoUrl, name }) => {
  const onClick = useTutorialClick(videoUrl, name);

  return (
    <Tooltip label="Video-Tutorial">
      <ThemeIcon
        id={id}
        size={20}
        style={{ cursor: 'pointer' }}
        variant="gradient"
        gradient={{ from: '#647c91', to: '#a2a7b0', deg: 135 }}
        sx={{ marginRight: 3 }}
      >
        <IconVideo data-testid={testId} color="white" onClick={onClick} />
      </ThemeIcon>
    </Tooltip>
  );
};

export const BookitupTutorialButtonV2: FC<BookitupTutorialIconProps & { label?: string }> = ({
  id,
  testId,
  videoUrl,
  name,
  label = 'Video-Tutorial',
}) => {
  const onClick = useTutorialClick(videoUrl, name);

  return (
    <Tooltip position="bottom" withArrow transition="slide-down" label={`${label} in der bookitup Academy ansehen`}>
      <Button
        id={id}
        size="xs"
        variant="filled"
        leftIcon={<IconSchool data-testid={testId} size={16} />}
        onClick={onClick}
      >
        {label}
      </Button>
    </Tooltip>
  );
};

export const BookitupTutorialButton: FC<BookitupTutorialIconProps & { label?: string }> = ({
  id,
  testId,
  videoUrl,
  name,
  label = 'Video-Tutorial',
}) => {
  const onClick = useTutorialClick(videoUrl, name);

  return (
    <Tooltip position="bottom" withArrow transition="slide-down" label={`${label} in der bookitup Academy ansehen`}>
      <Button
        compact
        id={id}
        size="xs"
        variant="outline"
        leftIcon={<IconSchool data-testid={testId} size={16} />}
        onClick={onClick}
      >
        {label}
      </Button>
    </Tooltip>
  );
};

export default BookitupTutorialIcon;
